import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const percentSolutionTool: Tool = {
  id: "percent-solution",
  name: () => m.pctsol_tool_name(),
  description: () => m.pctsol_tool_description(),
  icon: "🧫",
  basePath: "/percent-solution",
  status: "stable",
  tags: [
    "calculator",
    "chemistry",
    "science",
    "lab",
    "concentration",
    "percent",
  ],
};
